import { Question } from './question.interface';
import { QuestionId } from './question.model';
import { Category } from './category.model';
import { Answer } from './answer.model';

export class SimpleQuestion implements Question {
  constructor(
    private id: QuestionId = null,
    public type: string = null,
    public order: number = 0,
    public content: string = null,
    public secondaryContent: string = null,
    public comment: string = null,
    public category: Category = null,
    public answers: Answer[] = [],
    public userAnswers: Answer[] = [],
    public categoryVisible: boolean = false
  ) { }

  public getId(): QuestionId {
    return this.id;
  }

  public setOrder(order: number): void {
    this.order = order;
  }
}



// WEBPACK FOOTER //
// /dist/src/app/question/simple-question.model.ts